export const partnersFields = [];
